export type OrderOptimizerTaxiDetailsItemStepsOrdersPoints = {
  displayName: string;
  time: Date;
  haltingTime: number;
  distance: number;
  driverTime: Date | null;
  driverHaltingTime: number;
  driverDrivingTime: number;
  driverDistance: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerTaxiDetailsItemStepsEndToHome = {
  displayName: string;
  driverTime: Date;
  driverDrivingTime: number;
  driverDistance: number;
};

export type OrderOptimizerTaxiDetailsItemStepsOrders = {
  points: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[];
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerTaxiDetailsItemStepsHomeToStart = {
  displayName: string;
  driverTime: Date;
};

export type OrderOptimizerTaxiDetailsItemSteps = {
  homeToStart: OrderOptimizerTaxiDetailsItemStepsHomeToStart | null;
  orders: OrderOptimizerTaxiDetailsItemStepsOrders[];
  endToHome: OrderOptimizerTaxiDetailsItemStepsEndToHome | null;
};

export type OrderOptimizerTaxiDetailsItemOrdersByDriverSabs = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerTaxiDetailsItemOrdersByDriverAba = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerTaxiDetailsItemDriver = {
  driverId: string;
  displayName: string;
  taxiCorporation: string;
  startLat: number;
  startLon: number;
  contractRate: number;
};

export type OrderOptimizerTaxiDetailsItemOptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerTaxiDetailsItemUnoptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerTaxiDetailsItemOrders = {
  humanId: number;
  cargoCompany: string;
  billingModel: string;
  taxiCorporation: string;
  totalTime: number;
  haltingTime: number;
  distance: number;
  startTime: Date;
  planEntryHumanId: number | null;
  driverName: string | null;
  fleetPartner: string | null;
};

export enum OrderOptimizerTaxiDetailsItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

type OrderOptimizerTaxiDetailsItem = {
  reviewedBy: string | null;
  reviewedAt: Date | null;
  orders: OrderOptimizerTaxiDetailsItemOrders[];
  unoptimizedStats: OrderOptimizerTaxiDetailsItemUnoptimizedStats;
  optimizedStats: OrderOptimizerTaxiDetailsItemOptimizedStats;
  driver: OrderOptimizerTaxiDetailsItemDriver | null;
  ordersByDriverAba: OrderOptimizerTaxiDetailsItemOrdersByDriverAba | null;
  ordersByDriverSabs: OrderOptimizerTaxiDetailsItemOrdersByDriverSabs | null;
  saAndBsDistance: number;
  steps: OrderOptimizerTaxiDetailsItemSteps;
  score: number;
  status: OrderOptimizerTaxiDetailsItemStatus;
  totalCargoIncome: number;
  totalDriverHaltingCost: number;
};

export default OrderOptimizerTaxiDetailsItem;
